import cn from 'classnames';
import React, { memo } from 'react';

import { Divider, Layout, Logo, Space, Typography } from '@sravni/react-design-system';

import { COOKIE_HREF } from './KazakhstanPageFooter.config';
import styles from './KazakhstanPageFooter.module.scss';
import { kazakhstanPageFooterTexts } from './KazakhstanPageFooter.texts';

const { Link, Text } = Typography;

export const KazakhstanPageFooter = memo(() => (
  <footer data-qa="Footer" className={styles.footer}>
    <Divider />
    <Layout className={styles.logoContainer}>
      <Logo />
    </Layout>
    <Layout>
      <Space direction="vertical" size={20} className={styles.copyrights}>
        <Text className={cn(styles.copyrightsText, 'h-color-D30')}>
          <Text as="span" size={12}>
            {kazakhstanPageFooterTexts.aboutCompany}&nbsp;
          </Text>
          <Text as="span" size={12}>
            {kazakhstanPageFooterTexts.address}
          </Text>
        </Text>
        <Text size={12} className={cn(styles.copyrightsText, 'h-color-D60')}>
          {kazakhstanPageFooterTexts.companyActivities}
        </Text>
        <Text size={12} className={cn(styles.copyrightsText, 'h-color-D60')}>
          <Text as="span" size={12}>
            {kazakhstanPageFooterTexts.cookie}&nbsp;
          </Text>
          <Link href={COOKIE_HREF} color="dark" target="_blank">
            {kazakhstanPageFooterTexts.moreAboutTerms}
          </Link>
        </Text>
      </Space>
    </Layout>
  </footer>
));

KazakhstanPageFooter.displayName = 'KazakhstanPageFooter';
